// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---content-example-index-mdx": () => import("/zeit/54351995/content/example/index.mdx" /* webpackChunkName: "component---content-example-index-mdx" */),
  "component---content-index-mdx": () => import("/zeit/54351995/content/index.mdx" /* webpackChunkName: "component---content-index-mdx" */),
  "component---content-page-1-mdx": () => import("/zeit/54351995/content/page-1.mdx" /* webpackChunkName: "component---content-page-1-mdx" */),
  "component---content-example-page-2-mdx": () => import("/zeit/54351995/content/example/page-2.mdx" /* webpackChunkName: "component---content-example-page-2-mdx" */)
}

